module.exports = __webpack_public_path__ + "img/6-5.abea0dac.jpg";